import AccountCardAddressesModal, {
  ACCOUNT_CARD_ADDRESSES_MODAL,
} from './modal';

export { ACCOUNT_CARD_ADDRESSES_MODAL };

export default AccountCardAddressesModal;
